import React from "react";
import { Checkbox, Spinner } from "@ogt/ui";

interface TicketMachinesProps {
  enabled: boolean;
  onEnabledChange: (next: boolean) => void;
  onShowAll?: () => void;
  loading?: boolean;
}

export function TicketMachinesSection({
  enabled,
  onEnabledChange,
  onShowAll,
  loading = false,
}: TicketMachinesProps) {
  return (
    <Checkbox
      withLabel
      id="ticket-machines-toggle"
      checked={enabled}
      onCheckedChange={(v) => {
        const next = v === true;
        onEnabledChange(next);
        if (next) onShowAll?.();
      }}
      disabled={loading}
      className="min-h-4"
    >
      {loading ? (
        <span className="flex items-center h-4 gap-2">
          <Spinner className="w-4 h-4" />
          Laddar...
        </span>
      ) : enabled ? (
        "Dölj Biljettautomat"
      ) : (
        "Visa Biljettautomat"
      )}
    </Checkbox>
  );
}
